import React from "react";
import { motion } from "framer-motion";
import { Quote } from "lucide-react";

const PRESIDENT_IMG =
  "/assets/president-herve-diaz.jpg";

export const PresidentWord = () => {
  return (
    <section
      id="mot-president"
      data-testid="president-section"
      className="section-padding bg-[#FAF8F3] relative overflow-hidden"
    >
      <div className="absolute -top-10 -left-10 ecl-wordmark text-navy-500/[0.04]">ECL</div>

      <div className="container-edge relative z-10">
        <div className="grid grid-cols-12 gap-8 lg:gap-16 items-start">
          {/* Portrait */}
          <motion.div
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.8 }}
            className="col-span-12 md:col-span-5 lg:col-span-4"
          >
            <div className="relative">
              {/* Gold frame accent */}
              <div className="absolute -top-4 -left-4 w-16 h-16 border-t-2 border-l-2 border-navy-500 pointer-events-none" />
              <div className="absolute -bottom-4 -right-4 w-16 h-16 border-b-2 border-r-2 border-navy-500 pointer-events-none" />

              <div className="zoom-frame aspect-[4/5] bg-navy-700">
                <img
                  src={PRESIDENT_IMG}
                  alt="Hervé DIAZ — Président de l'École de Commerce de Lyon"
                  className="w-full h-full object-cover"
                  data-testid="president-portrait"
                />
              </div>
            </div>

            <div className="mt-8 pl-1">
              <div className="font-display text-2xl text-navy-700 leading-tight">Hervé DIAZ</div>
              <div className="overline text-navy-600 mt-2">Président — ECL</div>
              <div className="mt-4 flex items-center gap-3">
                <span className="red-rule" />
                <span className="font-display italic text-navy-500 text-sm">
                  Cor unum et anima una
                </span>
              </div>
            </div>
          </motion.div>

          {/* Letter */}
          <motion.div
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.8, delay: 0.15 }}
            className="col-span-12 md:col-span-7 lg:col-span-8"
          >
            <div className="overline mb-4">Mot du Président</div>
            <h2 className="font-display text-2xl sm:text-3xl md:text-4xl lg:text-5xl text-navy-700 leading-[1.1] mb-8 md:mb-10">
              « Le secret de l'éducation réside dans le respect de
              <em className="not-italic red-shine"> l'élève</em>. »
            </h2>

            <div className="space-y-5 text-[#444] text-[16px] leading-[1.75] max-w-2xl">
              <p>
                <span className="font-semibold text-navy-700">Emerson</span> a tout dit.
                Le reste n'est que déclinaisons.
              </p>

              <p>
                Au nom de toute l'équipe de l'École de Commerce de Lyon, je vous
                souhaite la bienvenue sur notre site internet. J'espère qu'il vous
                apportera les informations qui vous sont nécessaires.
              </p>

              <p>
                Vous allez y découvrir une école où chacun se place à votre service&nbsp;:
                staff, enseignants, étudiants. Car c'est là notre devise&nbsp;:
                <em className="text-navy-700"> Cor unum et anima una.</em>
                {" "}Un seul cœur, une seule âme.
              </p>

              <p>
                Bien sûr je ne peux que vous inviter à venir vivre l'expérience
                ECLYON et intégrer cette école où l'étudiant est placé au centre
                des attentions. Vous rejoindrez alors un corps uni et volontaire.
              </p>

              <div className="pl-6 border-l-2 border-navy-500 py-2 my-6">
                <p className="font-display italic text-navy-700 text-xl leading-snug">
                  Qui que vous soyez,<br />
                  étudiant ou enseignant,<br />
                  esprit généreux,<br />
                  <span className="text-navy-600">nous sommes prêts à vous accueillir.</span>
                </p>
              </div>

              <p className="text-navy-700">
                Votre bien dévoué,
              </p>
            </div>

            {/* Signature */}
            <div className="mt-8 flex items-end gap-4">
              <div
                className="font-display italic text-3xl text-navy-700 select-none"
                style={{ fontFamily: "'Playfair Display', serif", transform: "rotate(-2deg)" }}
              >
                Hervé Diaz
              </div>
              <div className="flex-1 h-px bg-navy-100 mb-2" />
              <Quote className="h-6 w-6 text-navy-500 mb-1" strokeWidth={1.2} />
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default PresidentWord;
